import React, { useState, useEffect } from "react";
import NotificationPopup from "../UI/Login/NotificationPopup";
import styled from "@emotion/styled";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Ripples from "react-ripples";

const Wrapper = styled.div`
  .profile-card {
    box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1),
      0px 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .profile-section {
    border-left: 1px solid #e5e7eb;
  }
  .active {
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.2) 0%,
      rgba(0, 97, 255, 0) 100%
    );
    border-right: 3px solid #0061ff;
  }
  .active-karaoke {
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.2) 0%,
      rgba(0, 97, 255, 0) 100%
    );
    border-right: 3px solid #4d00ff;
  }

  .active h5 {
    font-weight: 600 !important;
    color: #0061ff !important;
  }
  .active-karaoke h5 {
    font-weight: 600 !important;
    color: #4d00ff !important;
  }
  .urlHover:hover {
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.2) 0%,
      rgba(0, 97, 255, 0) 100%
    );
  }
  /* Утсан дээр цэс нь хэвтээ tab bar болно */
  @media (max-width: 767px) {
    .profile-section {
      border-left: none;
    }
    .profile-menu {
      border-bottom: 1px solid #e5e7eb;
      scrollbar-width: none;
    }
    .profile-menu::-webkit-scrollbar {
      display: none;
    }
    .active,
    .active-karaoke {
      background: rgba(0, 97, 255, 0.08);
      border-right: none;
      border-bottom: 3px solid #0061ff;
    }
    .active-karaoke {
      border-bottom-color: #4d00ff;
    }
  }
`;

const Profile = ({
  CKPopup,
  CKPopupType,
  CKPopupMessage,
  setCKPopup,
  isUserCanEdit,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const context = location.pathname.includes("/karaoke") ? "karaoke" : "music";

  // Extract section name from URL (3rd index: /music/profile/account)
  const currentSection = location.pathname.split("/")[3] || "";

  const [whichSection, setWhichSection] = useState(currentSection);

  useEffect(() => {
    setWhichSection(currentSection);
  }, [currentSection]);
  const changeSectionHandler = (section) => {
    if (whichSection !== section) {
      navigate(`/${context}/profile/${section}`);
    }
  };

  const menuItems = [
    { label: "Бүртгэлийн мэдээлэл", path: "" },
    { label: "Дансны тухай", path: "account" },
    ...(isUserCanEdit ? [{ label: "Нууц үг солих", path: "password" }] : []),
    { label: "Гэрээ", path: "contract" },
    { label: "Гэрээт уран бүтээлч", path: "artists" },
  ];

  return (
    <Wrapper className="p-4 md:p-8">
      <h5
        className={`font-semibold text-xl pb-3 md:pb-0 ${
          context === "karaoke" ? "text-mkaraoke" : "text-mmusic"
        }`}
      >
        Профайл
      </h5>
      <div className="profile-card h-full bg-white rounded-xl">
        <div className="flex flex-col md:flex-row">
          <div className="profile-menu flex flex-row md:flex-col w-full md:w-1/6 h-full md:gap-2 md:my-6 overflow-x-auto md:overflow-visible">
            {menuItems.map((item) => (
              <Ripples
                key={item.path}
                color="#0061FF40"
                during={600}
                className="flex-shrink-0 md:w-full"
              >
                <div
                  className={`px-4 md:px-6 py-3 md:py-2 w-full whitespace-nowrap md:whitespace-normal cursor-pointer urlHover ${
                    whichSection === item.path
                      ? context === "karaoke"
                        ? "active-karaoke"
                        : "active"
                      : ""
                  }`}
                  onClick={() => changeSectionHandler(item.path)}
                >
                  <h5 className="text-xs font-medium">{item.label}</h5>
                </div>
              </Ripples>
            ))}
          </div>
          <div className="profile-section w-full md:w-5/6 h-full">
            <Outlet />
          </div>
        </div>
      </div>
      <div className="absolute right-4 md:right-5 top-5">
        <NotificationPopup
          type={CKPopupType}
          popupMessage={CKPopupMessage}
          popup={CKPopup}
          setPopup={setCKPopup}
          animDirectionTop={true}
        />
      </div>
    </Wrapper>
  );
};

export default Profile;
